import ExtLink from 'components/common/ExtLink'
import RatingsBadge from 'components/common/RatingsBadge'
// import IntLink from 'components/common/IntLink'
import TelegramIcon from 'components/icons/TelegramIcon'
import VkIcon from 'components/icons/VkIcon'
import {
  ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  // FOOTER_ABOUT_PAGE_LIST,
  TELEGRAM_LINK,
  VK_LINK,
} from 'config/constants'
// import { getServices } from 'lib/getServices'
import { isNonEmptyArray } from 'lib/utils'
import Image from 'next/image'
import appStore from 'public/img/App_Store.png'
import googlePlay from 'public/img/Google_Play.png'
import RuStore from 'public/img/RuStore.png'
import img1 from 'public/img/footer1.png'
import img2 from 'public/img/footer2.png'
import img3 from 'public/img/footer3.png'
import img4 from 'public/img/footer4.png'
import img5 from 'public/img/footer5.png'
import {  useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectCities } from 'store/api'
import { useRouter } from 'next/router'

const FooterMbl = () => {
  const router = useRouter()
  const cities = useSelector(selectCities('ru'))

  // const [services, setServices] = useState<IService[]>([])

  const defaultCity = useMemo(
    () => (isNonEmptyArray(cities) ? cities[0] : null),
    [cities]
  )

  // useEffect(() => {
  //   void (async () => {
  //     const servicesData = await getServices('ru')
  //
  //     if (isPresent(servicesData)) {
  //       setServices(servicesData.services)
  //     }
  //   })()
  // }, [])

  // const openHours = useMemo(
  //   () =>
  //     `Ежедневно ${defaultCity?.call_time.begin || '08:00'} - ${
  //       defaultCity?.call_time.end || '20:00'
  //     }`,
  //   [defaultCity]
  // )

  // CLS-fix: не делаем early return null когда defaultCity ещё не загружен.
  // На SSR cities нет в Redux store, и старый `return null` приводил к тому,
  // что footer "вырастал" с 0 до ~600px после hydration → mobile CLS 0.434.
  // Все обращения к defaultCity внизу — через ?.X || FALLBACK, готовы к null.
  // if (isAbsent(defaultCity)) return null

  {/*
  const cateringComponent = (
    <div className='flex flex-col mt-6'>
      <IntLink
        href={`/catering`}
        className='text-base2 mb-2 !leading-6 font-bold text-dark uppercase'>
        Кейтеринг
      </IntLink>

      {services.map(({ name, slug }) => (
        <div key={slug}>
          <IntLink
            href={`/catering/${slug}`}
            className='line-clamp-1 text-base2 !leading-7 text-mediumDark'
          >
            {name}
          </IntLink>
        </div>
      ))}
    </div>
  )

  const aboutComponent = (
    <div className='flex flex-col mt-9'>
      <IntLink
        href={`/about`}
        className='text-base2 mb-2 !leading-6 font-bold text-dark uppercase'>
        О нас
      </IntLink>

      {FOOTER_ABOUT_PAGE_LIST.map((x) => (
        <div key={x.href}>
          <IntLink
            shallow={!x.deep}
            href={x.href}
            className='text-base2 !leading-6 text-mediumDark'
          >
            {x.name}
          </IntLink>
        </div>
      ))}
    </div>
  )
      */}

  const isLargePaddingBottom = router.pathname === '/cart';

  return (
    <footer className={`bg-lightGrey custom-px pt-9 md:pt-4 lg:bg-spoons-footer-pattern ${isLargePaddingBottom ? 'pb-[129px]' : 'pb-10'}`}>
      {/*
      {cateringComponent}
      {aboutComponent}
      */}

      <div className='grid grid-cols-2 justify-between gap-4 md:flex pb-4 lg:pb-2   '>
        <div className='lg:mt-8'>
          <div className='font-bold text-sm text-dark !leading-6'>
            Телефон:
          </div>
          <a
            className='text-mediumDark text-sm2 !leading-6'
            href={`tel:+${defaultCity?.phones[0]?.replace(/\D/g, '') ||
              CONTACT_PHONE.replace(/\D/g, '')
              }`}
          >
            {defaultCity?.phones[0] || CONTACT_PHONE}
          </a>
        </div>

        <div className='lg:mt-8'>
          <div className='font-bold text-sm text-dark !leading-6'>
            E-mail:{' '}
          </div>
          <a
            className='text-mediumDark text-base2 !leading-5 underline'
            href={`mailto:${CONTACT_EMAIL}`}
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className='flex flex-col lg:mt-8'>
          <div className='text-sm !leading-6 font-bold text-dark inline-flex items-center gap-2'>
            Адрес:
          </div>
          <div className='text-base2 !leading-7 text-mediumDark'>
            {defaultCity?.location?.address || ADDRESS}
          </div>
        </div>

        <div>
          <div className='font-bold text-sm text-dark !leading-7'>
            Режим работы:
          </div>

          <div className='flex flex-row gap-2'>
            <div className='text-gray-700 text-xs md:text-base2 !leading-5'>
              Пн-вс
            </div>
            <div className='text-mediumDark text-xs md:text-base2 !leading-5'>
              8:00–19:00
            </div>
          </div>
        </div>



        <div className='flex flex-row justify-center items-center row-start-4 col-span-2 md:col-span-1 mt-4'>
          <Image
            src={img1}
            layout='fixed'
            objectFit='contain'
            width='48px'
            height='26px'
            alt='Сертификат 1'
          />
          <Image
            src={img2}
            layout='fixed'
            objectFit='contain'
            width='48px'
            height='28px'
            alt='Сертификат 2'
          />
          <Image
            src={img3}
            layout='fixed'
            objectFit='contain'
            width='48px'
            height='26px'
            alt='Сертификат 3'
          />
          <Image
            src={img4}
            layout='fixed'
            objectFit='contain'
            width='68px'
            height='26px'
            alt='Сертификат 4'
          />
          <Image
            src={img5}
            layout='fixed'
            objectFit='contain'
            width='70px'
            height='26px'
            alt='Сертификат 5'
          />
        </div>

        <div className='row-start-5 col-span-2 mt-6'>
          <RatingsBadge variant='mbl' />
        </div>
      </div>

      <div className='flex flex-col-reverse md:flex-col mt-2'>
        <div className='flex justify-between flex-col items-center pt-6 border-t'>
          <div className='flex flex-col gap-1 items-center'>
            <span className='pb-2 md:pt-0 block text-dark/70 text-xs'>
              Мы в соцсетях:
            </span>
            <div className='flex gap-3 items-center'>
              <ExtLink title='ВКонтакте' aria-label='ВКонтакте' href={VK_LINK}>
                <VkIcon className='w-8 h-8 rounded hover:text-darkYellow' />
              </ExtLink>
              <ExtLink title='Телеграм' aria-label='Телеграм' href={TELEGRAM_LINK}>
                <TelegramIcon className='w-8 h-8 rounded hover:text-darkYellow' />
              </ExtLink>
            </div>
          </div>

          <div className='flex flex-col md:flex-row gap-1 md:gap-4 items-center md:pt-2 mt-4'>
            <span className='pb-2 md:pt-0 block text-dark/70 text-xs md:text-base2'>
              Скачивайте приложение:
            </span>
            <div className='flex flex-row gap-1 md:gap-3'>
              <ExtLink href='https://play.google.com/store/apps/details?id=com.moscowfood'>
                <Image
                  src={googlePlay}
                  layout='fixed'
                  objectFit='contain'
                  width='110px'
                  height='34px'
                  title='Google Play'
                  alt='Google Play'
                />
              </ExtLink>
              <ExtLink href='https://apps.apple.com/ru/app/moscowfood/id6447418248'>
                <Image
                  src={appStore}
                  layout='fixed'
                  objectFit='contain'
                  width='110px'
                  height='34px'
                  title='App Store'
                  alt='App Store'
                />
              </ExtLink>
              <ExtLink href='https://www.rustore.ru/catalog/app/com.moscowfood'>
                <Image
                  src={RuStore}
                  layout='fixed'
                  objectFit='contain'
                  width='110px'
                  height='34px'
                  title='RuStore'
                  alt='RuStore'
                />
              </ExtLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterMbl
